import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import DatePicker from './DatePicker';
import { apiRequest } from '../services/api';
import { useKasa } from '../context/KasaContext';

// ── Sabitler ──
var FATURA_TURLERI = ['TEMEL', 'TİCARİFATURA'];
var BIRIMLER = ['ADET', 'GECE', 'KİŞİ', 'PAKET', 'SAAT', 'GÜN'];

function pad(n) { return String(n).padStart(2, '0'); }
function bugunStr() {
  var d = new Date(); return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
}
function nowTime() {
  var d = new Date(); return pad(d.getHours()) + ':' + pad(d.getMinutes());
}

// ── Searchable Select (Premium) ──
function SSelect({ value, onChange, options, placeholder }) {
  var [open, setOpen] = useState(false);
  var [srch, setSrch] = useState('');
  var ref = useRef();
  useEffect(() => {
    function h(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  var filtered = options.filter(o => o.toLowerCase().includes(srch.toLowerCase()));
  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => { setOpen(v => !v); setSrch(''); }}
        className="w-full bg-slate-50 border-2 border-transparent hover:border-indigo-200 focus:border-indigo-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none uppercase tracking-widest transition-all flex items-center justify-between">
        <span className={value ? 'text-slate-700' : 'text-slate-400'}>{value || placeholder || 'SEÇİNİZ'}</span>
        <span className="text-indigo-400 text-[9px] ml-2">▼</span>
      </button>
      {open && (
        <div className="absolute z-50 mt-2 bg-white border border-slate-100 rounded-2xl shadow-2xl shadow-slate-200/50 min-w-full max-h-60 overflow-y-auto overflow-hidden animate-fade-in p-2">
          <div className="mb-2">
            <input autoFocus value={srch} onChange={e => setSrch(e.target.value)}
              className="w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-3 py-2 text-[10px] font-black text-slate-700 outline-none uppercase tracking-widest transition-all" placeholder="ARA..." />
          </div>
          {filtered.map(o => (
            <div key={o} onClick={() => { onChange(o); setOpen(false); }}
              className={`px-3 py-2 text-[10px] uppercase font-black tracking-widest cursor-pointer rounded-lg transition-all ${value === o ? 'bg-indigo-500 text-white' : 'text-slate-600 hover:bg-slate-50 hover:text-indigo-600'}`}>
              {o}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Ürün satırı ──
function UrunSatiri({ satir, onChange, onSil, index, urunKatalogu }) {
  var INP = "w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-2 py-2.5 text-[10px] font-black text-slate-700 outline-none uppercase tracking-widest transition-all";
  var toplam = (parseFloat(satir.miktar) || 0) * (parseFloat(satir.birimFiyat) || 0);
  var kdvTutar = toplam * (parseFloat(satir.kdv) || 0) / 100;
  var genelToplam = toplam + kdvTutar;

  var [ddAcik, setDdAcik] = useState(false);
  var [ddPos, setDdPos] = useState({ top: 0, left: 0, width: 0 });
  var btnRef = useRef();
  var ddRef = useRef();

  function hizliDoldur(urun) {
    onChange({ ...satir, ad: urun.ad, birim: urun.birim, birimFiyat: urun.birimFiyat, kdv: urun.kdv });
    setDdAcik(false);
  }

  function toggleDd() {
    if (!ddAcik && btnRef.current) {
      var r = btnRef.current.getBoundingClientRect();
      setDdPos({ top: r.bottom + window.scrollY + 4, left: r.left + window.scrollX, width: 260 });
    }
    setDdAcik(v => !v);
  }

  useEffect(() => {
    if (!ddAcik) return;
    function kapat(e) {
      if ((btnRef.current && btnRef.current.contains(e.target)) ||
          (ddRef.current && ddRef.current.contains(e.target))) return;
      setDdAcik(false);
    }
    document.addEventListener('mousedown', kapat);
    return () => document.removeEventListener('mousedown', kapat);
  }, [ddAcik]);

  return (
    <tr className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors group">
      <td className="px-2 py-3 text-[10px] font-black text-slate-300 text-center">{index + 1}</td>
      <td className="px-2 py-3 min-w-[200px]">
        <div className="flex gap-2">
          <input value={satir.ad} onChange={e => onChange({ ...satir, ad: e.target.value })}
            className={INP + ' flex-1'} placeholder="HİZMET ADI" />
          <div ref={btnRef} className="relative">
            <button onClick={toggleDd} className="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-400 hover:text-indigo-600 rounded-xl flex items-center justify-center transition-all font-black text-xs">▼</button>
            {ddAcik && createPortal(
              <div ref={ddRef} style={{ position: 'absolute', top: ddPos.top, left: ddPos.left, width: ddPos.width, zIndex: 10400 }}
                className="bg-white border border-slate-100 rounded-2xl shadow-2xl p-2 animate-fade-in max-h-60 overflow-y-auto">
                <p className="text-[9px] font-black tracking-widest text-slate-400 uppercase mb-2 pl-2 border-b border-slate-50 pb-2">Katalogdan Seç</p>
                {urunKatalogu.length === 0 && <p className="px-3 py-2 text-[10px] text-slate-400">Tanımlı hizmet bulunamadı.</p>}
                {urunKatalogu.map((u, i) => (
                  <div key={i} onMouseDown={() => hizliDoldur(u)}
                    className="px-3 py-2 text-[10px] font-black uppercase tracking-widest text-slate-600 cursor-pointer rounded-lg hover:bg-indigo-50 hover:text-indigo-600 transition-colors">
                    {u.ad}
                  </div>
                ))}
              </div>,
              document.body
            )}
          </div>
        </div>
      </td>
      <td className="px-2 py-3">
        <div className="relative">
          <select value={satir.birim} onChange={e => onChange({ ...satir, birim: e.target.value })}
            className={INP + ' pr-6 appearance-none cursor-pointer text-center'}>
            {BIRIMLER.map(b => <option key={b}>{b}</option>)}
          </select>
          <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-indigo-400 text-[9px]">▼</span>
        </div>
      </td>
      <td className="px-2 py-3">
        <input type="number" min="1" value={satir.miktar} onChange={e => onChange({ ...satir, miktar: e.target.value })}
          className={INP + ' w-16 text-center'} />
      </td>
      <td className="px-2 py-3">
        <input type="number" value={satir.birimFiyat} onChange={e => onChange({ ...satir, birimFiyat: e.target.value })}
          className={INP + ' w-24 text-right'} />
      </td>
      <td className="px-2 py-3">
        <div className="relative flex items-center">
          <span className="absolute left-2 text-slate-400 text-[11px] pointer-events-none">%</span>
          <input type="number" min="0" max="100" value={satir.kdv}
            onChange={e => onChange({ ...satir, kdv: e.target.value })}
            className={INP + ' pl-5 w-16 text-center'} />
        </div>
      </td>
      <td className="px-2 py-3 text-right text-[11px] font-black text-slate-500 whitespace-nowrap">
        {kdvTutar.toFixed(2)} ₺
      </td>
      <td className="px-2 py-3 text-right text-[12px] font-black text-emerald-600 whitespace-nowrap">
        {genelToplam.toFixed(2)} ₺
      </td>
      <td className="px-2 py-3 text-center">
        <button onClick={onSil} className="w-8 h-8 rounded-full bg-rose-50 hover:bg-rose-100 text-rose-400 hover:text-rose-600 flex items-center justify-center transition-colors font-black opacity-30 group-hover:opacity-100 mx-auto">×</button>
      </td>
    </tr>
  );
}

// ── Ana Modal ──
// rezervasyon prop: { rezervasyonId, misafirAdi, tcNo, email, sehir, ilce, adres, odaTutari, geceSayisi, odaAdi, adisyonlar? }
export default function YeniFaturaModal({ onKapat, onFaturaKesildi, rezervasyon }) {
  var { odemeTipleri, gelirGruplari } = useKasa();
  // Veritabanı Değerleri
  var [odaTipleri, setOdaTipleri] = useState([]);

  // Fatura bilgileri
  var [faturaTarihi, setFaturaTarihi] = useState(bugunStr());
  var [faturaSaati, setFaturaSaati] = useState(nowTime());
  var [faturaTuru, setFaturaTuru] = useState('TEMEL');
  var [odemeTip, setOdemeTip] = useState('');
  var [aciklama, setAciklama] = useState('');

  // Alıcı bilgileri — rezervasyon prop'undan ön doldur
  var [tcVergi, setTcVergi] = useState(rezervasyon?.tcNo || '');
  var [vergiDairesi, setVergiDairesi] = useState('');
  var adSoyadParcala = (rezervasyon?.misafirAdi || '').trim().split(' ');
  var [ad, setAd] = useState(adSoyadParcala.slice(0, -1).join(' ') || rezervasyon?.misafirAdi || '');
  var [soyad, setSoyad] = useState(adSoyadParcala.length > 1 ? adSoyadParcala[adSoyadParcala.length - 1] : '');
  var [unvan, setUnvan] = useState('');
  var [email, setEmail] = useState(rezervasyon?.email || '');
  var [telefon, setTelefon] = useState('');
  var [ulke, setUlke] = useState('TÜRKİYE');
  var [sehir, setSehir] = useState(rezervasyon?.sehir || '');
  var [ilce, setIlce] = useState(rezervasyon?.ilce || '');
  var [adres, setAdres] = useState(rezervasyon?.adres || '');

  // Ürün satırları — rezervasyondan ön doldur
  var ilkSatirlar = (function() {
    var defaultKdv = rezervasyon?.firmaId ? 0 : 10;
    var base = rezervasyon
      ? [{ id: 1, ad: 'Konaklama Bedeli' + (rezervasyon.odaAdi ? ' — ' + rezervasyon.odaAdi : ''), birim: 'GECE', miktar: rezervasyon.geceSayisi || 1, birimFiyat: rezervasyon.odaTutari || 0, kdv: defaultKdv }]
      : [{ id: 1, ad: 'Konaklama Hizmet Bedeli', birim: 'GECE', miktar: 1, birimFiyat: 0, kdv: defaultKdv }];
    // Adisyon kalemleri ayrı satır olarak ekle
    var ekstraSatirlar = (rezervasyon?.adisyonlar || []).map(function(a, i) {
      return { id: 100 + i, ad: a.stokAdi || 'Hizmet', birim: 'ADET', miktar: a.miktar || 1, birimFiyat: a.birimFiyat || 0, kdv: 10 };
    });
    return [...base, ...ekstraSatirlar];
  })();
  var [satirlar, setSatirlar] = useState(ilkSatirlar);
  var [konaklamaVergisiOrani, setKonaklamaVergisiOrani] = useState(rezervasyon?.firmaId ? 0 : 2);

  // Onay durumu
  var [yukleniyor, setYukleniyor] = useState(false);
  var [kaydedildi, setKaydedildi] = useState(false);
  var [sonucNo, setSonucNo] = useState('');
  var [hata, setHata] = useState(null);

  // Ödeme tipi: KasaContext'ten geliyor, ilk değeri setle
  useEffect(() => {
    if (odemeTipleri && odemeTipleri.length > 0 && !odemeTip) {
      setOdemeTip(odemeTipleri[0].ad || '');
    }
  }, [odemeTipleri]); // eslint-disable-line

  // DB'den oda tiplerini çek
  useEffect(() => {
    apiRequest('OdaTipi', 'GET')
      .then(res => { if (res) setOdaTipleri(res.filter(o => o.aktifMi !== false)); })
      .catch(e => console.warn('OdaTipi çekilemedi:', e));
  }, []);


  function satirEkle() {
    setSatirlar(prev => [...prev, { id: Date.now(), ad: '', birim: 'ADET', miktar: 1, birimFiyat: 0, kdv: 10 }]);
  }
  function satirGuncelle(id, yeni) {
    setSatirlar(prev => prev.map(s => s.id === id ? yeni : s));
  }
  function satirSil(id) {
    setSatirlar(prev=> prev.filter(s => s.id !== id));
  }

  var urunKatalogu = [
    ...odaTipleri.map(o => ({ ad: 'Konaklama (' + o.ad + ')', birim: 'GECE', birimFiyat: 0, kdv: 10 })),
    ...gelirGruplari.map(g => ({ ad: g.ad, birim: 'ADET', birimFiyat: 0, kdv: 10 })),
  ];

  var araToplam = satirlar.reduce((acc, s) => acc + (parseFloat(s.miktar) || 0) * (parseFloat(s.birimFiyat) || 0), 0);
  var toplamKdv = satirlar.reduce((acc, s) => acc + ((parseFloat(s.miktar) || 0) * (parseFloat(s.birimFiyat) || 0)) * (parseFloat(s.kdv) || 0) / 100, 0);
  var konaklamaVergisi = araToplam * (konaklamaVergisiOrani / 100);
  var genelToplam = araToplam + konaklamaVergisi + toplamKdv;

  var kdvGruplari = {};
  satirlar.forEach(s => {
    var oran = parseFloat(s.kdv) || 0;
    var st = (parseFloat(s.miktar) || 0) * (parseFloat(s.birimFiyat) || 0);
    var kdvT = st * oran / 100;
    if (!kdvGruplari[oran]) kdvGruplari[oran] = { matrah: 0, kdv: 0 };
    kdvGruplari[oran].matrah += st;
    kdvGruplari[oran].kdv += kdvT;
  });

  async function kaydetVeGonder() {
    if (!tcVergi) { setHata('Lütfen T.C. Kimlik veya Vergi Numarası giriniz.'); return; }
    if (!ad && !unvan) { setHata('Lütfen alıcı ad/soyad veya ünvan bilgisini giriniz.'); return; }
    if (satirlar.length === 0 || araToplam <= 0) { setHata('En az bir geçerli ürün kalemi olması gereklidir.'); return; }

    setYukleniyor(true); setHata(null);

    // Dto formatına mapping: (Backend tek kalemlik Dto bekliyor - O yüzden birleştiriyoruz)
    var birlesikAciklama = satirlar.map(s => s.ad).join(' + ');
    var agirlikliKdv = araToplam > 0 ? Math.round((toplamKdv / araToplam) * 100) : 10;
    
    var dto = {
      aliciVkn: tcVergi,
      aliciAdSoyad: unvan || (ad + ' ' + soyad),
      aliciAdres: adres || '-',
      aliciSehir: sehir || '-',
      aliciIlce: ilce || '-',
      faturaNo: '',
      tarih: (function(){ const n=new Date(); return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,'0')}-${String(n.getDate()).padStart(2,'0')}T${String(n.getHours()).padStart(2,'0')}:${String(n.getMinutes()).padStart(2,'0')}:00`; })(),
      paraBirimi: 'TRY',
      eArsiv: !(tcVergi.length === 10 && /^\d{10}$/.test(tcVergi)),
      kalemAdi: birlesikAciklama,
      kalemFiyat: araToplam,
      kdvOrani: agirlikliKdv,
      konaklamaVergisi: true,
      odemeTipi: odemeTip || null,
      rezervasyonId: rezervasyon?.rezervasyonId || null,
    };

    try {
      var res = await apiRequest('efatura/gonder', 'POST', dto);
      setSonucNo(res.faturaNo || res.uuid || 'EdmBaşarılı');
      setKaydedildi(true);
      onFaturaKesildi?.();
    } catch(err) {
      setHata(err.message || 'Fatura EDM\'ye gönderilemedi.');
    } finally {
      setYukleniyor(false);
    }
  }

  var INP = "w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none uppercase tracking-widest transition-all placeholder:text-slate-300";
  var LBL = "block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 pl-2";

  if (kaydedildi) {
    return (
      <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-md z-[10300] flex items-center justify-center p-4">
        <div className="bg-white rounded-[3rem] shadow-2xl shadow-indigo-900/20 w-full max-w-sm p-12 text-center animate-fade-in relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-emerald-400 rounded-full blur-3xl opacity-20"></div>
          
          <div className="w-24 h-24 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl shadow-emerald-500/30">
            <span className="text-4xl text-white">✓</span>
          </div>
          <h2 className="text-2xl font-black text-slate-800 tracking-tighter mb-2">Fatura Kesildi!</h2>
          <p className="text-[10px] font-black tracking-widest uppercase text-slate-400 mb-6 bg-slate-50 py-2 rounded-xl border border-slate-100">{sonucNo}</p>
          
          <div className="space-y-4 mb-8 text-left">
             <div className="flex justify-between items-center bg-slate-50 p-4 rounded-2xl">
               <span className="text-[10px] font-black tracking-widest uppercase text-slate-400">ALICI</span>
               <span className="text-xs font-black text-slate-800 max-w-[150px] truncate text-right">{unvan || (ad + ' ' + soyad)}</span>
             </div>
             <div className="flex justify-between items-center bg-slate-50 p-4 rounded-2xl">
               <span className="text-[10px] font-black tracking-widest uppercase text-slate-400">TUTAR</span>
               <span className="text-lg font-black text-emerald-600">{genelToplam.toFixed(2)} ₺</span>
             </div>
          </div>

          <button onClick={onKapat} className="w-full bg-slate-800 hover:bg-black text-white font-black text-[11px] uppercase tracking-widest py-4 rounded-2xl transition-all shadow-lg active:scale-95">ÖZETE DÖN</button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-md z-[10300] p-4 sm:p-6 overflow-y-auto" style={{ paddingTop: '5vh' }}>
      <div className="bg-white rounded-[3rem] shadow-2xl w-full max-w-[1200px] mx-auto overflow-hidden animate-fade-in mb-20 border border-slate-100 relative">
        {/* Loading Overlay */}
        {yukleniyor && (
           <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center">
             <div className="w-16 h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-6"></div>
             <p className="text-lg font-black text-indigo-900 tracking-tighter">İşlem Yapılıyor...</p>
             <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mt-2 animate-pulse">EDM Servislerine Bağlanılıyor, Lütfen Bekleyin</p>
           </div>
        )}

        {/* Header */}
        <div className="flex items-center justify-between px-8 sm:px-12 py-8 bg-gradient-to-r from-slate-800 to-indigo-900">
          <div>
            <h2 className="text-3xl font-black text-white tracking-tighter">YENİ E-FATURA KES</h2>
            <p className="text-[10px] font-black text-indigo-300 uppercase tracking-widest mt-2 bg-white/10 px-3 py-1 inline-block rounded-full">Resmi GİB / EDM Portalı</p>
          </div>
          <button onClick={onKapat} className="w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-all font-black text-xl backdrop-blur-sm">×</button>
        </div>

        <div className="px-8 sm:px-12 py-8 space-y-10">
          {hata && <div className="bg-rose-50 border border-rose-200 text-rose-700 px-6 py-4 rounded-2xl text-xs font-black uppercase tracking-widest animate-fade-in flex items-center gap-3"><span>⚠️</span> {hata}</div>}

          <div className="flex items-center gap-4 border-b-2 border-slate-50 pb-4">
            <div className="w-8 h-8 rounded-full bg-indigo-50 border-2 border-indigo-200 flex items-center justify-center font-black text-indigo-600 text-xs">1</div>
            <h3 className="text-sm font-black text-slate-800 tracking-widest uppercase">FATURA BİLGİLERİ</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div>
              <label className={LBL}>Fatura Türü</label>
              <div className="relative">
                <select value={faturaTuru} onChange={e => setFaturaTuru(e.target.value)} className={INP + ' appearance-none cursor-pointer'}>
                  {FATURA_TURLERI.map(f => <option key={f}>{f}</option>)}
                </select>
                <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-indigo-400 text-[9px]">▼</span>
              </div>
            </div>
            <div>
              <label className={LBL}>Fatura Tarihi</label>
              <DatePicker value={faturaTarihi} onChange={setFaturaTarihi} />
            </div>
            <div>
              <label className={LBL}>Fatura Saati</label>
              <input type="time" value={faturaSaati} onChange={e => setFaturaSaati(e.target.value)} className={INP} />
            </div>
            <div>
              <label className={LBL}>Ödeme Tipi</label>
              <SSelect value={odemeTip} onChange={setOdemeTip} options={odemeTipleri.map(o => o.ad || '')} />
            </div>
          </div>


          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b-2 border-slate-50 pb-4 mt-8">
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-indigo-50 border-2 border-indigo-200 flex items-center justify-center font-black text-indigo-600 text-xs">2</div>
              <h3 className="text-sm font-black text-slate-800 tracking-widest uppercase">ALICI BİLGİLERİ</h3>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="lg:col-span-2">
               <label className={LBL}>T.C Kimlik / Vergi No <span className="text-rose-500">*</span></label>
               <input value={tcVergi} onChange={e=>setTcVergi(e.target.value)} className={INP} placeholder="TC, VKN veya Pasaport No" />
               <p className="text-[8px] font-black tracking-widest text-slate-400 mt-2 pl-2">11 haneli TC → e-Arşiv · 10 haneli VKN → e-Fatura · Pasaport No → e-Arşiv</p>
            </div>
            <div className="lg:col-span-2">
               <label className={LBL}>Kayıtlı Vergi Dairesi</label>
               <input value={vergiDairesi} onChange={e=>setVergiDairesi(e.target.value)} className={INP} placeholder="SADECE KURUMSAL İÇİN" />
            </div>

            <div>
              <label className={LBL}>Alıcı Adı <span className="text-rose-500">*</span></label>
              <input value={ad} onChange={e=>setAd(e.target.value)} className={INP} placeholder="İSİM" />
            </div>
            <div>
              <label className={LBL}>Alıcı Soyadı <span className="text-rose-500">*</span></label>
              <input value={soyad} onChange={e=>setSoyad(e.target.value)} className={INP} placeholder="SOYİSİM" />
            </div>
            <div className="col-span-2">
              <label className={LBL}>E-Posta Adresi</label>
              <input value={email} onChange={e=>setEmail(e.target.value)} className={INP} placeholder="ORNEK@MAIL.COM" type="email"/>
            </div>

            <div className="col-span-2 lg:col-span-4">
              <label className={LBL}>Firma / Şirket Ünvanı</label>
              <input value={unvan} onChange={e=>setUnvan(e.target.value)} className={INP} placeholder="KURUMSAL KESİMLER İÇİN TAM MAHKEME ÜNVANI..." />
            </div>

            <div className="col-span-2 lg:col-span-2">
              <label className={LBL}>Adres Bilgisi</label>
              <input value={adres} onChange={e=>setAdres(e.target.value)} className={INP} placeholder="TAM ADRES..." />
            </div>
            <div>
              <label className={LBL}>İl / Şehir</label>
              <input value={sehir} onChange={e=>setSehir(e.target.value)} className={INP} placeholder="İSTANBUL" />
            </div>
            <div>
              <label className={LBL}>İlçe</label>
              <input value={ilce} onChange={e=>setIlce(e.target.value)} className={INP} placeholder="KADIKÖY" />
            </div>
          </div>


          {/* 3: HİZMETLER */}
          <div className="flex items-center justify-between border-b-2 border-slate-50 pb-4 mt-8">
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-indigo-50 border-2 border-indigo-200 flex items-center justify-center font-black text-indigo-600 text-xs">3</div>
              <h3 className="text-sm font-black text-slate-800 tracking-widest uppercase">EKLENEN HİZMETLER</h3>
            </div>
            <button onClick={satirEkle} className="bg-indigo-50 hover:bg-indigo-100 text-indigo-600 font-black text-[9px] uppercase tracking-widest px-4 py-2.5 rounded-xl transition-all border border-indigo-100">+ SATIR EKLE</button>
          </div>

          <div className="bg-white rounded-3xl border border-slate-100 shadow-xl overflow-x-auto custom-scrollbar">
            <table className="w-full text-left min-w-[900px]">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-center w-12">#</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest pl-4">Hizmet Açıklaması</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-center w-28">Birim</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-center w-24">Mik.</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-right w-36">Birim.Fiyati</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-center w-24">KDV</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-right w-32">KDV Tutari</th>
                  <th className="py-4 px-2 text-[9px] font-black text-slate-400 uppercase tracking-widest text-right w-32 pr-4">Tutar (KDV Dahil)</th>
                  <th className="py-4 px-2 w-12"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {satirlar.map((s, i) => <UrunSatiri key={s.id} satir={s} index={i} onChange={y => satirGuncelle(s.id, y)} onSil={() => satirSil(s.id)} urunKatalogu={urunKatalogu} />)}
              </tbody>
            </table>
            {satirlar.length === 0 && <div className="text-center py-12 text-[10px] font-black text-slate-400 uppercase tracking-widest">En az bir adet hizmet kalemi girmelisiniz.</div>}
          </div>

          
          {/* ALT ÖZET VE NOT */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 pt-4">
            <div className="flex flex-col">
              <label className={LBL}>Fatura Notları & Ekstra Açıklama (Alt Gövde)</label>
              <textarea value={aciklama} onChange={e=>setAciklama(e.target.value)} rows={5}
                className="w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-3xl p-5 text-xs font-black text-slate-600 outline-none uppercase tracking-widest transition-all resize-none shadow-inner" placeholder="E-Fatura eklentisinde alt gövde metni. Hesap numaraları vb. buraya eklenebilir." />
            </div>

            <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-[2.5rem] p-8 text-white shadow-2xl relative overflow-hidden">
               <div className="absolute -top-20 -right-20 w-48 h-48 bg-indigo-500 rounded-full blur-3xl opacity-20"></div>
               
               <h4 className="text-[10px] font-black tracking-widest text-indigo-400 uppercase pb-4 mb-4 border-b border-slate-700">Fatura Malî Özeti</h4>
               
               <div className="space-y-3">
                 {Object.entries(kdvGruplari).map(([oran, v]) => (
                   <div key={oran} className="bg-slate-800/50 rounded-xl p-3">
                     <div className="flex justify-between text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">
                       <span>Matrah (%{oran} KDV)</span>
                       <span>{v.matrah.toFixed(2)} ₺</span>
                     </div>
                     <div className="flex justify-between text-[10px] font-black text-indigo-300 uppercase tracking-widest">
                       <span>Hesaplanan KDV (%{oran})</span>
                       <span>{v.kdv.toFixed(2)} ₺</span>
                     </div>
                   </div>
                 ))}
               </div>

               <div className="mt-6 pt-6 border-t border-slate-700 space-y-4">
                  <div className="flex justify-between items-center text-xs font-black text-slate-300 uppercase tracking-widest">
                    <span>Brüt Ara Toplam</span>
                    <span>{araToplam.toFixed(2)} ₺</span>
                  </div>
                  <div className="flex justify-between items-center text-xs font-black text-slate-300 uppercase tracking-widest">
                    <div className="flex items-center gap-2">
                      <span>Konaklama Vergisi</span>
                      <div className="flex items-center gap-1 bg-slate-700 rounded-lg px-2 py-1 border border-slate-600">
                        <span className="text-slate-400 text-[10px]">%</span>
                        <input type="number" min="0" max="100" step="0.5" value={konaklamaVergisiOrani}
                          onChange={e => setKonaklamaVergisiOrani(parseFloat(e.target.value) || 0)}
                          className="w-10 bg-transparent text-[11px] text-center text-white outline-none" />
                      </div>
                      {rezervasyon?.firmaId && <span className="text-[9px] text-violet-400 uppercase">(Firma)</span>}
                    </div>
                    <span>{konaklamaVergisi.toFixed(2)} ₺</span>
                  </div>
                  <div className="flex justify-between items-center text-xs font-black text-slate-300 uppercase tracking-widest">
                    <span>Toplam KDV</span>
                    <span>{toplamKdv.toFixed(2)} ₺</span>
                  </div>
                  <div className="flex justify-between items-end pt-4 mt-4 border-t border-slate-700">
                    <div>
                      <span className="block text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-1">ÖDENECEK</span>
                      <span className="text-3xl font-black tracking-tighter">GENEL TOPLAM</span>
                    </div>
                    <span className="text-3xl font-black text-emerald-400 tracking-tighter">{genelToplam.toFixed(2)} ₺</span>
                  </div>
               </div>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="px-8 sm:px-12 py-6 bg-slate-50 border-t border-slate-100 flex flex-col-reverse sm:flex-row items-center justify-between gap-4">
           {tcVergi.length === 10 && /^\d{10}$/.test(tcVergi) ? (
             <div className="flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest"><span className="text-lg">🏢</span> KURUMSAL E-FATURA KESİLECEK</div>
           ) : tcVergi.length > 0 ? (
             <div className="flex items-center gap-2 bg-amber-100 text-amber-700 px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest"><span className="text-lg">📧</span> E-ARŞİV KESİLECEK</div>
           ) : <div/>}

           <div className="flex gap-4 w-full sm:w-auto">
             <button onClick={onKapat} className="flex-1 sm:flex-none border-2 border-slate-200 hover:border-slate-300 bg-white text-slate-600 font-black text-[10px] uppercase tracking-widest px-8 py-4 rounded-2xl transition-all">İptal Vazgeç</button>
             <button onClick={kaydetVeGonder} className="flex-1 sm:flex-none bg-gradient-to-r from-emerald-400 to-teal-500 hover:from-emerald-500 hover:to-teal-600 text-white font-black text-[11px] uppercase tracking-[0.2em] px-10 py-4 rounded-2xl shadow-xl shadow-emerald-500/30 transition-all active:scale-95 flex items-center justify-center gap-2">
                 ⚡ FATURAYI EDM'YE GÖNDER
             </button>
           </div>
        </div>

      </div>
    </div>
  );
}